import { defineComponent as _defineComponent } from 'vue'
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
  import { Chart, ChartItem, TooltipItem } from "chart.js";
  import { computed, nextTick, ref, watch } from "vue";
  import { numFormatter } from "@/helpers/transformation/number";

  const barItemColor = "#8ED6F1";
  const barItemColorActive = "#49C1EE";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardSale',
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const chartRef = ref(null as unknown as Chart);

  const lineChart = ref({
    id: "bar",
    type: "bar",
    data: {
      labels: [""],
      datasets: [
        {
          data: [0],
          backgroundColor: [barItemColorActive],
          hoverBackgroundColor: barItemColorActive,
          borderWidth: 0,
        },
      ],
    },
    options: {
      onHover: function (e, item: ChartItem[]) {
        let colors = e.chart.config.data.datasets[0].backgroundColor;
        let color = item.length ? barItemColor : barItemColorActive;

        colors.forEach((item: string, index: number) => {
          colors[index] = color;
        });
        e.chart.update();
      },
      animation: {
        y: {
          duration: 300,
          easing: "linear",
        },
      },
      borderRadius: 3,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          // Disable the on-canvas tooltip
          enabled: false,
          external: function (context) {
            // Tooltip Element
            let tooltipEl = document.getElementById("chartjs-tooltip");

            // Create element on first render
            if (!tooltipEl) {
              tooltipEl = document.createElement("div");
              tooltipEl.id = "chartjs-tooltip";
              tooltipEl.innerHTML = "<div></div>";
              document.body.appendChild(tooltipEl);
            }

            // Hide if no tooltip
            const tooltipModel = context.tooltip;

            if (tooltipModel.opacity === 0) {
              tooltipEl.style.opacity = "0";
              return;
            }

            function getBody(bodyItem) {
              return bodyItem.lines;
            }

            // Set Text
            if (tooltipModel.body) {
              const titleLines = tooltipModel.title || [];
              const bodyLines = tooltipModel.body.map(getBody);

              let innerHtml = "<div>";

              titleLines.forEach(function (title) {
                innerHtml +=
                  '<div class="chart-tooltip-title">' + title + "</div>";
              });
              bodyLines.forEach(function (body: string[]) {
                const stringWithSpacesToNumber = Number(
                  body[0].replace(/\s/g, "").replace(/,/g, "")
                );

                innerHtml +=
                  "<span>" +
                  "$" +
                  numFormatter(stringWithSpacesToNumber) +
                  "</span>";
              });
              innerHtml += "</div>";

              let tableRoot = tooltipEl.querySelector("div");

              if (tableRoot) {
                tableRoot.innerHTML = innerHtml;
              }
            }

            const position = context.chart.canvas.getBoundingClientRect();

            tooltipEl.classList.add("chart-tooltip-triangle");
            Object.assign(tooltipEl.style, {
              background: "white",
              border: "1px solid #EBEBF4",
              borderRadius: "5px",
              opacity: "1",
              position: "absolute",
              padding: "9px 22px",
              left:
                position.left + window.pageXOffset + tooltipModel.caretX + "px",
              top:
                position.top + window.pageYOffset + tooltipModel.caretY + "px",
              pointerEvents: "none",
              transition: "0.2s",
              fontWeight: 700,
              textAlign: "center",
              transform: "translate(-50%, calc(-100% - 15px))",
            });
          },
        },
      },
      layout: {
        padding: {
          top: 0,
          right: 0,
          left: -22,
          bottom: 0,
        },
      },
      scales: {
        xAxes: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            color: "#7171a2",
            font: {
              weight: "600",
            },
          },
        },
        yAxes: {
          grid: {
            display: true,
            color: "#e7e7e7",
            borderDash: [3, 3],
            lineWidth: 1,
            drawBorder: false,
            drawTicks: false,
          },
          ticks: {
            fontSize: 10,
            fontFamily: "Inter",
            lineHeight: "20px",
            padding: 22,
            color: "#b5b5c3",
            min: 1000,
            callback: function (value: number) {
              if (value > 0) {
                return "$" + numFormatter(value);
              } else return 0;
            },
          },
        },
      },
    },
  });
  const getTotalSale = computed(() => {
    let result = lineChart.value.data.datasets[0].data;
    let count = 0;

    if (result) {
      count = result.reduce((acc, item) => {
        return acc + item;
      }, 0);
      return numFormatter(count);
    } else return "0";
  });

  watch(
    () => props.data,
    (newValue) => {
      updatedData(newValue);
    },
    { immediate: true, deep: true }
  );

  function updatedData(data: any) {
    const newArray = { ...data };

    lineChart.value.data.labels = newArray.dates;
    lineChart.value.data.datasets[0].data = newArray.values;
    nextTick(() => updateChart());
  }

  function updateChart() {
    chartRef.value.update();
  }

const __returned__ = { props, chartRef, barItemColor, barItemColorActive, lineChart, getTotalSale, updatedData, updateChart, get Vue3ChartJs() { return Vue3ChartJs }, get Chart() { return Chart }, get ChartItem() { return ChartItem }, get TooltipItem() { return TooltipItem }, computed, nextTick, ref, watch, get numFormatter() { return numFormatter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})